export const AREAS_ENUM = {
  'Admin': 1,
  'Administración': 2,
  'Dirección General': 3,
  'Dirección de Equipo': 4,
  'Nutrición': 5,
  'Pediatría': 6,
  'Psicopedagogía': 7,
  'Atención Temprana': 8,
  'Trabajo Social': 9,
  'Fonoaudiología': 10,
  'Obstetricia': 12,
  'Educación Para La Salud': 14,
  'Oficios': 15,
  'Comunicación': 16,
  'Interconsulta': 17,
  'Psicología': 18,
  'Logística': 19,
  'Acompañamiento Hospitalario': 20,
  'At. temprana y desarrollo del lenguaje': 21,
  'Sala de Jardín': 22,
  'Dirección Regional': 23,
  'Talleres': 24,
  'Pasantía': 25,
  'Educación Sanitaria': 26,
  'Acompañante Familiar': 27,
  'Auxiliar de dirección': 28,
  'Desarrollo de fondos': 29
}

export const COMMUNITY_MONITORING_AREAS = [
  AREAS_ENUM['Admin'],
  AREAS_ENUM['Dirección General'],
  AREAS_ENUM['Dirección de Equipo'],
  AREAS_ENUM['Dirección Regional']
]
